import { Injectable } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { LocalStorageService } from './localStorage.service';
import * as $ from 'jquery';
import { MatDialog } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class GeneratepdfService {
  _pdetails: any;
  _loaderflag = false;

  constructor(public _localstorage: LocalStorageService, public modal: NgbModal, public dialog: MatDialog) { }

  public generatePdfFile() {
    // Loading Processed data.
    this._pdetails = JSON.parse(this._localstorage.getItem('patientdetails'));
    // Initializing  jspdf() and variables.
    const pdf = new jspdf('p', 'pt', 'a4', true);
    // Total Page Count.
    let pgTotalCnt = 1;
    // Total Calendar Count.
    let totalCalCnt = 0;
    const stringSizeMM = (72 / 25.6);
    const top = 20;
    const left = 15;
    const rightpadding = 5;
    const rightmargin = 10;
    const bottomMargin = 10;
    const smallRadius = 3;
    const mediumRadius = 5;
    const largeRadius = 30;
    const boxWidth = 565;
    const boxTextWidth = 540;
    const tcTextWidth = 540;
    const bottomSpace = 20;
    const fontSmall = 8;
    const fontMedium = 10;
    const fontLarge = 12;
    const fontXL = 14;
    const fontLabel = 16;
    const fontXXL = 18;
    const lineHeightSmall = 10;
    const lineHeightMedium = 12;
    const lineHeightLarge = 14;
    const footerY = 832;
    // PDF First Page Start.
    // Header start.
    let hY = 45;
    // Header Title start.
    pdf.setFont('helvetica', 'normal');
    pdf.setTextColor('#081871');
    pdf.setFontSize(fontXXL);
    const header = $('.calender-header.new-pdf-header');
    const hTitlef = header.find('h2').text();
    console.log(hTitlef);
    // const hTitle = hTitlef.replace('Darzalex ®','Darzalex®')
    pdf.triangle(left + rightmargin, hY - 12, left + rightmargin + 14, hY - 12, left + rightmargin + 7, hY, 'FD');
    pdf.text(hTitlef, left + 22 + rightpadding, hY);
    // Header Title end.
    // Header Date Start.
    pdf.setFontSize(fontLabel);
    pdf.setTextColor('#00a59d');
    const hDateLabel = header.find('.fechadate .date-txt').text();
    hY += bottomSpace;
    pdf.text(hDateLabel, left + rightpadding, hY);
    let hDateLabelWidth = pdf.getStringUnitWidth(hDateLabel);
    hDateLabelWidth = hDateLabelWidth * 16;
    pdf.setFontSize(fontLarge);
    pdf.setTextColor('#4d4e53');
    const hDate = header.find('.fechadate span').text();
    pdf.text(hDate, hDateLabelWidth + left + rightmargin, hY);
    pdf.setTextColor('#00a59d');
    pdf.setFontSize(fontLabel);
    const hLeyendaLabel = header.find('.leyenda h3').text();
    pdf.setFillColor('#009999');
    hY += bottomSpace;
    pdf.text(hLeyendaLabel, left + rightpadding, hY);
    pdf.setFontSize(fontXL);
    let hLeyendaLabelWidth = pdf.getStringUnitWidth(hLeyendaLabel);
    hLeyendaLabelWidth = hLeyendaLabelWidth * 16;
    pdf.setTextColor('#4d4e53');
    const hLeyenda = header.find('.leyenda .circle-list > span');
    let hLeyendaListWidth = 1;
    hLeyenda.each(function () {
      if (!$(this).hasClass('holiday-notation')) {
        const rgbColor = $(this).find('i').css('color');
        const rgb = rgbColor.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
        const hexColor = (rgb && rgb.length === 4) ? ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2)
          + ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
        pdf.setFillColor('#' + hexColor);
        pdf.circle(hLeyendaLabelWidth + left + hLeyendaListWidth + 8, hY - 5, smallRadius, 'F');
        pdf.text($(this).text(), hLeyendaLabelWidth + left + rightpadding + hLeyendaListWidth + 5, hY);
        let hLeyendaWidth = pdf.getStringUnitWidth($(this).text());
        hLeyendaWidth = hLeyendaWidth * 16;
        hLeyendaListWidth += hLeyendaWidth;
      }
    });
    pdf.setFontSize(fontLarge);
    const notation = header.find('.leyenda .holiday-notation').text();
    const festWidth = pdf.getStringUnitWidth(notation);
    pdf.setFillColor('#006E00');
    pdf.setTextColor('#FFFFFF');
    pdf.roundedRect(hLeyendaLabelWidth + hLeyendaListWidth + left + rightpadding, hY - 15, festWidth * 14, 20,
       smallRadius, smallRadius, 'F');
    pdf.text(notation, hLeyendaLabelWidth + hLeyendaListWidth + left + rightpadding + 5, hY);
    pdf.setTextColor('#00a59d');
    pdf.setFontSize(fontLabel);
    const htreatLabel = header.find('.treatments h3').text();
    hY += bottomSpace;
    pdf.text(htreatLabel, left + rightpadding, hY);
    pdf.setTextColor('#4d4e53');
    pdf.setFontSize(fontMedium);
    const htreatAll = header.find('.leyenda-list span div span');
    let htreatLeft = left + rightpadding;
    hY += bottomSpace;
    htreatAll.each(function () {
      const htreat = $(this).text();
      if (htreatLeft > 400) {
        hY += bottomSpace;
        htreatLeft = left + rightpadding;
        pdf.text(htreat, htreatLeft, hY);
      } else {
        pdf.text(htreat, htreatLeft, hY);
      }
      let htreatWidth = pdf.getStringUnitWidth(htreat);
      htreatWidth = htreatWidth * 10;
      htreatLeft += htreatWidth;
      htreatLeft += rightmargin;
    });
    pdf.setDrawColor('#385D8A');
    pdf.roundedRect(left, top, boxWidth, hY - 40, smallRadius, smallRadius, 'S');
    pdf.setTextColor('#000000');
    // Medication fill start.
    let mY = hY + bottomMargin - 5;
    const mLH = lineHeightSmall;
    $('.medicationtext .PatientDosepanenl').each(function (index) {
      const info_label = $(this).children('.Dosetitle').text();
      const paraContentDose = $(this).children('.Dose-vails').find('textarea').text().split('\n');
      const paraLengthDose = paraContentDose.length;
      let pD = 0;
      pdf.setFontSize(fontMedium);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor('#040767');
      pdf.text(`${info_label}`, left + rightmargin, mY + 3);
      pdf.setFontSize(fontSmall);
      pdf.text('1', left + pdf.getStringUnitWidth(info_label) * fontMedium + 11, mY - 10 + bottomMargin);
      // if (index === 0) {
      //   pdf.text('1', left + pdf.getTextWidth(info_label) * 1.34, mY - 10 + bottomMargin);
      // }
      // else if (index === 1) {
      //   pdf.text('1', left + pdf.getTextWidth(info_label) * 1.33, mY - 10 + bottomMargin);
      // }
      // else {
      //   pdf.text('1', left + pdf.getTextWidth(info_label) * 1.29, mY - 10 + bottomMargin);
      // }
      pdf.setFontSize(fontSmall);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor('#000000');
      mY += 12 + 3;
      for (pD = 0; pD < paraLengthDose; pD++) {
        const paraText = paraContentDose[pD].replace('≤', 'MENOS QUE O IGUAL A');
        const splitTitleDose = pdf.splitTextToSize(paraText, boxTextWidth);
        const clD = splitTitleDose.length.toString();
        pdf.text(splitTitleDose, left + rightmargin, mY);
        mY = mY + (clD * mLH);
      }
      mY += 12;
    });
    pdf.setDrawColor('#519dd4');
    pdf.roundedRect(left, hY - 33 + bottomMargin + 10, boxWidth, mY - hY + 10, largeRadius, largeRadius, 'S');
    // Medication fill end.
    // Observastion start
    // Printing observation if entered.
    let oY = mY + bottomMargin;
    const rectTop = oY;
    let obserHeight = oY - rectTop;
    if ($.trim($('.textarea-observation').text()).length) {
      const oLH = lineHeightMedium;
      pdf.setFontSize(fontMedium);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor('#040767');
      pdf.text($localize`:@@observationHeader:Observaciones`, left, oY + bottomMargin);
      const paraContent = $('.textarea-observation').text().split('\n');
      const paraLength = paraContent.length;
      let p = 0;
      pdf.setFontSize(fontSmall);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor('#000000');
      oY += bottomMargin;
      oY += 10;
      for (p = 0; p < paraLength; p++) {
        let splitTitleObs = paraContent[p].replace('≤', 'MENOS QUE O IGUAL A');
        splitTitleObs = pdf.splitTextToSize(splitTitleObs, boxTextWidth);
        const clO = splitTitleObs.length.toString();
        pdf.text(splitTitleObs, left + rightpadding, oY + 10);
        oY = oY + (clO * oLH);
      }
      pdf.setDrawColor('#cccccc');
      obserHeight = oY - rectTop;
      pdf.rect(left, rectTop + bottomMargin + 5, boxWidth, obserHeight - 5, 'S');
      obserHeight += 10;
    }
    // Observation end.
    // First page bottom content start.
    let bY = rectTop + obserHeight + bottomMargin + 5;
    const bLH = lineHeightSmall;
    pdf.setDrawColor('#000000');
    pdf.setFontSize(fontMedium);
    pdf.triangle(left + rightmargin, bY - 7, left + rightmargin + 6, bY - 7, left + rightmargin + 3, bY, 'FD');
    const splitTitleF = pdf.splitTextToSize($localize`:@@additionalmentoringtext:(   ) Este medicamento está sujeto a seguimiento adicional, es prioritaria la notificación de sospechas de reacciones adversas asociadas a este medicamento.`, 540);
    pdf.text(splitTitleF, left + rightpadding, bY);
    const clF = splitTitleF.length.toString();
    bY = bY + (clF * bLH) + bottomMargin;
    pdf.text($localize`:@@summaryProduct:1. Ficha Técnica de Darzalex`, left + rightpadding, bY);
    bY = bY + lineHeightMedium;
    const splitTitleS = pdf.splitTextToSize($localize`:@@MDuseOnlytext:Uso exclusivo del Médico, para más información consulte la sección 4.2 y 5.1 de la Ficha Técnica de Darzalex disponible en la web de la Agencia Española de Medicamentos y Productos Sanitarios: https://cima.aemps.es/cima/publico/home.html`, 540);
    pdf.text(splitTitleS, left + rightpadding, bY + 5);
    const clS = splitTitleS.length.toString();
    bY = bY + (clS * bLH) + 15;
    const splitTitleT = pdf.splitTextToSize($localize`:@@ContentDownlaodedtmsg:Material descargado de https://www.janssenmedicalcloud.es. Elemento descargado a partir del material CP-81821 MAYO 2020`, 540);
    pdf.text(splitTitleT, left + rightpadding, bY);
    // First page bottom content end.
    pdf.addPage();
    pgTotalCnt++;
    // PDF First Page end.
    // PDF Calendar Page Start.
    let calRowY = top;
    $('.cals-parent .cal-pdf-print').each(function () {
      const monthtitle = $(this).find('.month-title').text();
      let dataleft = left;
      pdf.setFontSize(fontLabel);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor('#000000');
      const calhead = $(this).find('.cal-header .cal-cell');
      const caldays = $(this).find('.cal-days .cal-day-number');
      const caldaycell = $(this).find('.cal-days .cal-day-cell');
      const holidayDetails = [];
      const cycleDetails = [];
      const bulletDetails = [];
      const countDetails = [];
      let haveBullet = false;
      let dateStart = false;
      const rowList = [];
      let rowMaxCnt = 0;
      let rowCnt = 0;
      let rowNum = 1;
      caldaycell.each(function () {
        const dayNum = $(this).find('.cal-day-number').text();
        // dayNum = parseInt(dayNum, dayNum);
        let bulletHolidayCnt = 0;
        if (dayNum.toString() === '1') {
          dateStart = !dateStart;
        }
        if (dateStart) {
          let filldataH = '';
          $(this).find('.holidayevent').each(function () {
            if (filldataH !== '') {
              filldataH += '|';
            }
            filldataH += $(this).text();
            bulletHolidayCnt++;
          });
          holidayDetails[dayNum] = filldataH;
          let filldataC = '';
          $(this).find('.cal-day-badge').each(function () {
            if (filldataC !== '') {
              filldataC += '|';
            }
            filldataC += $(this).text();
          });
          cycleDetails[dayNum] = filldataC;
          let filldataB = '';
          $(this).find('.eventbullets').each(function () {
            const rgbColor = $(this).find('i').css('background-color');
            const rgb = rgbColor.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
            const hexColor = (rgb && rgb.length === 4) ?
              ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2)
              + ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
            if (filldataB !== '') {
              filldataB += '|';
            }
            filldataB += $(this).text() + '#' + hexColor;
            haveBullet = true;
            bulletHolidayCnt++;
          });
          bulletDetails[dayNum] = filldataB;
          countDetails[dayNum] = bulletHolidayCnt;
        }
        rowCnt++;
        if (rowMaxCnt < bulletHolidayCnt) {
          rowMaxCnt = bulletHolidayCnt;
        }
        if (rowCnt === 7) {
          rowCnt = 0;
          rowList[rowNum] = rowMaxCnt;
          rowNum++;
          rowMaxCnt = 0;
        }
      });
      const daysList = [];
      let dlicnt = 0;
      caldays.each(function () { daysList[dlicnt] = $(this).text(); dlicnt++; });
      pdf.setFontSize(fontMedium);
      if (haveBullet) {
        totalCalCnt++;
        calRowY += bottomSpace;
        pdf.setFont('helvetica', 'normal');
        // To get total rows.
        const calTotalRow = Math.trunc((daysList.length / 7));
        // To Print month title.
        pdf.setFontSize(fontXL);
        pdf.text(monthtitle, 240, calRowY);
        // To find Height of the Calendar.
        let calHeight = 30;
        for (let chi = 1; chi <= calTotalRow; chi++) {
          calHeight += 50;
          let extraHtPtF = 0;
          if (rowList[chi] > 3) {
            const extraHtF = rowList[chi] - 3;
            extraHtPtF = extraHtF * 14;
          }
          calHeight += extraHtPtF;
        }
        calRowY += 10;
        // Adding weekend grey.
        pdf.setFillColor('#dddddd');
        pdf.rect(415, calRowY, 160, calHeight - 10, 'F');
        // Drawing outer line.
        pdf.setDrawColor('#666666');
        pdf.rect(left, calRowY, 560, calHeight - 10, 'S');
        // Adding Calendar header.
        calRowY += bottomSpace;
        pdf.setFontSize(fontLarge);
        pdf.setTextColor('#212529');
        pdf.line(left, calRowY, 575, calRowY, 'S');
        dataleft = left;
        calhead.each(function () {
          pdf.text($.trim($(this).text()).toString(), dataleft + 20, calRowY - 8);
          dataleft += 80;
        });
        // To draw vertical line.
        let ccx = left;
        for (let cc = 0; cc < 7; cc++) {
          ccx += 80;
          pdf.line(ccx, calRowY, ccx, calRowY + calHeight - 30, 'S');
        }
        // To draw Horizontal lines.
        for (let cr = 1; cr <= calTotalRow; cr++) {
          dataleft = 80;
          pdf.setFontSize(fontMedium);
          pdf.setFont('times', 'normal');
          const rowStart = (7 * (cr - 1));
          const rowLimit = rowStart + 7;
          for (let di = rowStart; di < rowLimit; di++) {
            pdf.setTextColor('#000000');
            let dataPrint = true;
            pdf.setFont('times', 'normal');
            pdf.setFontSize(fontSmall);
            if (cr === 1 && daysList[di] > 20) {
              pdf.setTextColor('#cccccc');
              dataPrint = false;
            }
            if (cr === calTotalRow && daysList[di] < 20) {
              pdf.setTextColor('#cccccc');
              dataPrint = false;
            }
            pdf.text(daysList[di], dataleft, calRowY + 12);
            if (dataPrint && $.trim(cycleDetails[daysList[di]]) !== '') {
              pdf.setFont('helvetica', 'bold');
              pdf.setFillColor('#b94a48');
              pdf.setFontSize(fontSmall);
              pdf.setTextColor('#ffffff');
              pdf.roundedRect(dataleft - 48, calRowY + 2, 36, 10, 5, 5, 'F');
              pdf.text(cycleDetails[daysList[di]], dataleft - 47, calRowY + 10);
            }
            let tt = 20;
            if (dataPrint && $.trim(holidayDetails[daysList[di]]) !== '') {
              pdf.setFont('helvetica', 'bold');
              pdf.setFontSize(fontSmall);
              const holiday = holidayDetails[daysList[di]].split('|');
              for (let hi = 0; hi < holiday.length; hi++) {
                if (hi) {
                  tt += lineHeightMedium;
                }
                pdf.setFillColor('#006E00');
                pdf.roundedRect(dataleft - 65, calRowY + tt - 6, 80, 10, smallRadius, smallRadius, 'F');
                pdf.setTextColor('#ffffff');
                pdf.text(holiday[hi], dataleft - 50, calRowY + tt + 2);
              }
              pdf.setTextColor('#000000');
              tt += lineHeightMedium;
            }
            if (dataPrint && $.trim(bulletDetails[daysList[di]]) !== '') {
              pdf.setFont('helvetica', 'normal');
              pdf.setFontSize(fontSmall);
              const bullet = bulletDetails[daysList[di]].split('|');
              for (let bi = 0; bi < bullet.length; bi++) {
                if (bi) {
                  tt += lineHeightMedium;
                }
                const bulletColor = bullet[bi].split('#');
                pdf.setFillColor('#' + bulletColor[1]);
                pdf.circle(dataleft - 60, calRowY + tt - 3, smallRadius, 'F');
                pdf.setTextColor('#000000');
                pdf.text(bulletColor[0], dataleft - 55, calRowY + tt);
              }
            }
            dataleft += 80;
          }
          if (rowList[cr] > 3) {
            const extraHt = rowList[cr] - 3;
            const extraHtPt = extraHt * 14;
            calRowY += extraHtPt;
          }
          calRowY += 50;
          pdf.line(15, calRowY, 575, calRowY, 'S');
        }

        if (!(totalCalCnt % 2)) {
          pdf.addPage();
          pgTotalCnt++;
          calRowY = top;
        } else {
          calRowY += bottomSpace;
        }
      }
    });
    // PDF Calendar Page end.
    // PDF Terms and condition Page Start.
    const tcleft = left + rightpadding;
    pdf.setTextColor('#000000');
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(fontSmall);
    const tcpagetop = top + bottomMargin;
    let tcy = tcpagetop;
    const tcpagebottom = 800;
    if ((totalCalCnt % 2)) {
      tcy = calRowY;
    }
    const tclh = lineHeightSmall;
    let tcContent = '';
    const tcxh = 7;
    $('.terms-conditions .printable-section').each(function () {
      $(this).children().each(function () {
        const tagProcess = $(this).prop('tagName');
        console.log(tagProcess);
        // $('MARKDOWN.printable-section').each(function(){
        //   $(this).children().each(function () {
        //     const tagProcess1 = $(this).prop('tagName');
        //     console.log(tagProcess1);

        switch (tagProcess) {
          case 'DIV':
            pdf.setFont('helvetica', 'bold');
            tcContent = $(this).text();
            if (tcContent.trim()) {
              tcContent = tcContent.replace('≤', 'MENOS QUE O IGUAL A');
              const splitTitleTC = pdf.splitTextToSize(tcContent, tcTextWidth);
              const clTC = splitTitleTC.length.toString();
              // console.log('coming here', tcContent !== '');
              pdf.text(splitTitleTC, tcleft + 173, tcy);
              pdf.text('___________________________________________', tcleft + 175, tcy);
              tcy = tcy + (clTC * tclh);
              tcy += tcxh;
            }
            break;
          case 'UL':
            pdf.setFont('helvetica', 'normal');
            $(this).children('li').each(function () {
              tcContent = $(this).text();
              if (tcContent.trim()) {
                // tcContent = tcContent.replace('≤', 'MENOS QUE O IGUAL A');
                const splitTitleTCUL = pdf.splitTextToSize(tcContent, tcTextWidth - 15);
                const clTCUL = splitTitleTCUL.length.toString();
                pdf.setFillColor('#000000');
                pdf.setDrawColor('#000000');
                if ($(this).hasClass('beforePdf')) {
                  pdf.rect(tcleft + 53, tcy - 5, 3, 3, 'F');
                } else {
                  pdf.circle(tcleft + 10, tcy - 3, 2, 'F');
                }
                // console.log('coming here ul', typeof (tcContent), tcContent === '', tcContent === null);
                if ($(this).hasClass('addunderline')) {
                  pdf.text(splitTitleTCUL, tcleft + 20, tcy - 2);
                  pdf.text('____________________________________', tcleft + 22, tcy - 2);
                  tcy = tcy + (clTCUL * tclh) - 5;
                } else {
                  pdf.text(splitTitleTCUL, tcleft + 20, tcy);
                  tcy = tcy + (clTCUL * tclh);
                }
                if (tcy > tcpagebottom) {
                  tcy = tcpagetop;
                  pdf.addPage();
                  pgTotalCnt++;
                }
                tcy += (tcxh - 2);
              }
            });
            tcy += tcxh;
            break;
          case 'P':
            pdf.setFont('helvetica', 'normal');
            if (!$(this).hasClass('nopadding')) {
              if ($(this).hasClass('addItalic')) {
                pdf.setFont('helvetica', 'italic');
              }
              $(this).each(function () {
                tcContent = $(this).text();
                if (tcContent !== '') {
                  tcContent = tcContent.replace('≤', 'MENOS QUE O IGUAL A');
                  const splitTitleTCUL = pdf.splitTextToSize(tcContent, tcTextWidth - 30);
                  const clTCUL = splitTitleTCUL.length.toString();
                  pdf.setFillColor('#000000');
                  pdf.setDrawColor('#000000');
                  if ($(this).hasClass('beforePdf')) {
                    pdf.rect(tcleft + 33, tcy - 5, 3, 3, 'F');
                  }
                  pdf.text(splitTitleTCUL, tcleft + 30, tcy);
                  tcy = tcy + (clTCUL * tclh) - 5;
                  if ((tcy + 30) > tcpagebottom) {
                    tcy = tcpagetop;
                    pdf.addPage();
                    pgTotalCnt++;
                  }
                  tcy += (tcxh - 2);
                }
              });
            } else {
              $(this).each(function () {
                tcContent = $(this).text();
                if (tcContent !== '') {
                  tcContent = tcContent.replace('≤', 'MENOS QUE O IGUAL A');
                  const splitTitleTCUL = pdf.splitTextToSize(tcContent, tcTextWidth - 15);
                  const clTCUL = splitTitleTCUL.length.toString();
                  pdf.setFillColor('#000000');
                  pdf.setDrawColor('#000000');
                  pdf.text(splitTitleTCUL, tcleft, tcy);
                  tcy = tcy + (clTCUL * tclh);
                  if (tcy > tcpagebottom) {
                    tcy = tcpagetop;
                    pdf.addPage();
                    pgTotalCnt++;
                  }
                  tcy += (tcxh - 2);
                }
              });
            }
            tcy += tcxh;
            break;
          default:
            pdf.setFont('helvetica', 'normal');
            tcContent = $(this).text();
            if (tcContent !== '') {
              tcContent = tcContent.replace('≤', 'MENOS QUE O IGUAL A');
              const splitTitle = pdf.splitTextToSize(tcContent, tcTextWidth);
              const cl = splitTitle.length.toString();
              if (tcy + (cl * tclh) > tcpagebottom) {
                tcy = tcpagetop;
                pdf.addPage();
                pgTotalCnt++;
              }
              pdf.text(splitTitle, tcleft, tcy);
              tcy = tcy + (cl * tclh);
              tcy += tcxh;
            }
        }

        if (tcy > tcpagebottom) {
          tcy = tcpagetop;
          pdf.addPage();
          pgTotalCnt++;
        }
      });

    });
    // PDF Terms and condition Page end.
    // PDF Footer Start.
    if (pgTotalCnt) {
      pdf.setFontSize(fontMedium);
      pdf.setTextColor('#666666');
      for (let fti = 1; fti <= pgTotalCnt; fti++) {
        pdf.setPage(fti);
        pdf.setFont('times', 'normal');
        pdf.text($localize`:@@monthyear:[Placeholder for footer: month / year of last update, local Janssen company]`, 40, footerY);
        const cnt = fti + $localize`:@@from: de ` + pgTotalCnt;
        const pg = cnt.toString();
        pdf.setFont('times', 'italic');
        pdf.text(pg, 550, footerY);
      }
    }
    // PDF Footer end.
    // PDF Metadata start.
    pdf.setDocumentProperties({
      title: 'Darzalex Calendar',
      subject: 'Darzalex Calendar',
      author: 'j&j',
      creator: 'j&j'
    });
    pdf.addMetadata('Darzalex Calendar', '/');
    // PDF metadata end.
    // PDF Download Start.
    // Prepare File name.

    const mydate = new Date();
    const year = mydate.getFullYear();
    const month = ('0' + (mydate.getMonth() + 1)).slice(-2);
    const date = ('0' + mydate.getDate()).slice(-2);
    const formatedDate = date.toString() + '_' + month.toString() + '_' + year.toString().substr(2, 2);

    const fileName = formatedDate + '_' + $localize`:@@savedFileName:'Darzalex_Calendar_en` + '_' + this._pdetails.Tratamientos;
    if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())) {
      pdf.save(fileName + '.pdf');
    } else {
      const newFileName = prompt($localize`:@@fileName:nombre de archivo`, fileName);
      if (newFileName != null) {
        pdf.save(newFileName + '.pdf');
      }
    }
    // PDF Download end.
  }

}
